import React, { useState, useEffect } from "react";
import AboutContent from "./AboutContent";
import BrandShowcase from "./BrandShowcase";
import AboutFeatures from "./AboutFeatures";
import StoreLocationMap from "./StoreLocationMap";
import AboutVideo from "./AboutVideo";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import HomeFeatures from "../Home/HomeFeatures";

const About = () => {
  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, []);

  return (
    <>
      <Header />
      <AboutVideo />
      <AboutContent />
      <BrandShowcase />
      <HomeFeatures />
      <StoreLocationMap />
      {/* <Footer /> */}
    </>
  );
};

export default About;
